import {
  IonIcon, IonLabel,
  IonPage,
} from '@ionic/react';
import { chevronBackOutline } from 'ionicons/icons';
import { useHistory } from 'react-router-dom';

import FaqList from '@/components/common/FaqList/FaqList';
import useMediaQuery, { Breakpoint } from '@/hooks/useMediaQuery';

import styles from './Faq.module.scss';

export default function Faq() {
  const history = useHistory();
  const isTablet = useMediaQuery(Breakpoint.Tablet);
  return (
    !isTablet ? (
      <IonPage>
        <div className={styles.ionPageHelp}>
          {!isTablet && (
            <div className={styles.pageContactTitle}>
              <IonIcon
                md={chevronBackOutline}
                className={styles.pageContactTitleIcon}
                onClick={() => {
                  history.goBack();
                }}
              />
              <IonLabel className={styles.pageContactTitleInfo}>
                Preguntas frecuentes
              </IonLabel>
            </div>
          )}
          <FaqList />
        </div>
      </IonPage>
    ) : (
      <div className={styles.help}>
        <FaqList />
      </div>
    )
  );
}
